import { useState } from 'react'

export interface FatoresRiscoPreEclampsiaModalPayload {
  isModalFatoresRiscoPreEclampsiaOpen: boolean
  openModalFatoresRiscoPreEclampsia(): void
  closeModalFatoresRiscoPreEclampsia(): void
}

export function useFatoresRiscoPreEclampsiaModal(): FatoresRiscoPreEclampsiaModalPayload {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  return {
    isModalFatoresRiscoPreEclampsiaOpen: isModalOpen,
    openModalFatoresRiscoPreEclampsia: openModal,
    closeModalFatoresRiscoPreEclampsia: closeModal,
  }
}
